import Created from './Created';
import Error from './Error';
import File from './File';
import Id from './Id';
import Status from './Status';
import Type from './Type';
import Username from './Username';

export const labels = {
  Id: '#',
  File: 'Fájl',
  Status: 'Státusz',
  Error: 'Hibaüzenet',
  Type: 'Típus',
  Username: 'Felhasználó',
  Created: 'Dátum',
};

export const allColumns = [
  {
    value: 'Id',
    fixed: true,
  }, {
    value: 'File',
  },{
    value: 'Status',
  }, {
    value: 'Error',
  }, {
    value: 'Type',
  }, {
    value: 'Username',
  }, {
    value: 'Created',
  }
];

export const defaultColumns = [
  {
    value: 'Id',
    fixed: true,
  }, {
    value: 'File',
  },{
    value: 'Status',
  }, {
    value: 'Error',
  }, {
    value: 'Type',
  }, {
    value: 'Username',
  }, {
    value: 'Created',
  }
];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  File,
  Username,
  Status,
  Error,
  Type,
  Created,
};
